export const createArray = (size) => new Array(size).fill(null);
//# sourceMappingURL=array.js.map